/**
 * Static star rating
 */

export default (() => {
  const customStarSVG = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5376_13090)">
      <path d="M0.0786743 8.66123H9.13939L10.2357 11.9099L7.4065 13.9852L0.0786743 8.66123Z" fill="white"/>
      <path d="M6.72336 16.2393L4.63215 22.6754L11.9998 17.3225L12.0133 17.3322L22.1577 9.91228L22.1721 9.93188L23.921 8.66123H14.814L11.9998 0L9.89474 6.47881L11.9134 12.4606L11.8421 12.4846L6.72336 16.2393Z" fill="white"/>
      <path d="M17.0124 15.427L13.2144 18.2049L19.3675 22.6754L17.0124 15.427Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_5376_13090">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
      `

  function getRatingLevel(value) {
    if (value < 2) return 'terrible'
    if (value < 3) return 'poor'
    if (value < 4) return 'average'
    if (value < 4.2) return 'good'
    return 'excellent'
  }

  document.querySelectorAll('.static-rating').forEach((container) => {
    const rating = parseFloat(container.dataset.rating)
    const level = getRatingLevel(rating)
    container.classList.add(`rating-${level}`)

    const full = Math.floor(rating)
    const partial = rating - full
    const boxes = container.querySelectorAll('.star-box')

    boxes.forEach((box, index) => {
      const fill = box.querySelector('.star-fill')
      const icon = box.querySelector('.star-icon')
      icon.innerHTML = customStarSVG

      if (index < full) {
        fill.style.width = '100%'
      } else if (index === full) {
        fill.style.width = `${partial * 100}%`
      } else {
        fill.style.width = '0%'
      }
    })
  })
})()
